import { supabase } from "../../supabaseClient"
import { loadClient } from "./client"

export const saveVehicle = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('Vehicle')
            .update({ ...item })
            .match({ id })
        } else {
            return await supabase
            .from('Vehicle')
            .insert([{ ...item, id_company: item.company }], {skipDuplicates:true})
    }
}

export const getExistedPlate = async ({ plate, companyId, excludeVehicleId } = {}) => {
    const clients = await loadClient(companyId);
    const clientIds = clients.map((client) => client.id);

    const { data, error } = await supabase
        .from('Vehicle')
        .select('*')
        .in('responsible', clientIds)
        .eq('plate', plate)
        .is('deleted_at', null);

    if (error) return [];

    return excludeVehicleId
        ? data.filter((vehicle) => vehicle.id !== excludeVehicleId)
        : data;
}